export default __webpack_public_path__ + "static/media/indoor_good.bb98adb5.jpg";